import Header, { HeaderPropTypes } from './Header';

export { HeaderPropTypes };
export default Header;
